import React from "react";

class DefaultBottom extends React.Component {
  render() {
    const { dataSource } = this.props;
    return (
      <div className={`bottom-dia-group-box ${this.props.className}`}>
        {dataSource.map((v) => (
          <div className='item'>
            <img src={v.icon} alt='' />
            <span>{v.name}</span>
            <span>共{v.children.length}项</span>
          </div>
        ))}
      </div>
    );
  }
}

export default DefaultBottom;



// WEBPACK FOOTER //
// ./src/AntD/pages/diagnosticManage/diagnosticAnalysis/defaultBottom.js